import { JSX } from "react";
import { ProjectService } from "../projects";
import BulkProviderChangeReports from "../shared/BulkProviderChangeReports";

const projectService = new ProjectService();
const ViewMyTargets = (): JSX.Element => {
  const endpoint = () => projectService.getBulkProviderTargetExports();
  return <BulkProviderChangeReports endpoint={endpoint} title="Volume Targeting" buttonTerm="Targets" />;
};

export default ViewMyTargets;
